import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { userApi } from '../../services/api'
import Button from '../../components/common/Button'
import Input from '../../components/common/Input'
import toast from 'react-hot-toast'

export default function Users() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [users, setUsers] = useState([])
  const [search, setSearch] = useState('')

  useEffect(() => {
    loadUsers()
  }, [])

  async function loadUsers() {
    setLoading(true)
    try {
      const response = await userApi.getAll()
      if (response.success) {
        setUsers(response.users || [])
      } else {
        toast.error('Failed to load users')
      }
    } catch (error) {
      toast.error('Error loading users')
    }
    setLoading(false)
  }

  const filteredUsers = users.filter(user => {
    if (!search) return true
    const searchLower = search.toLowerCase()
    return (
      user.userName?.toLowerCase().includes(searchLower) ||
      user.fullName?.toLowerCase().includes(searchLower) ||
      user.email?.toLowerCase().includes(searchLower)
    )
  })

  return (
    <div>
        {/* Header */}
        <div className="page-header flex items-center justify-between">
            <div>
                <h1 className="page-title">Users</h1>
                <p className="text-blue-100 mt-1">{filteredUsers.length} users</p>
            </div>
            <div className="flex gap-2">
                <Button onClick={() => navigate('/admin/users/new')}>
                    + Add User
                </Button>
                <Button variant="secondary" onClick={() => navigate('/')}>
                    ← Dashboard
                </Button>
            </div>
        </div>

      {/* Search */}
      <div className="bg-white rounded-xl shadow-md p-4 mb-6">
        <Input
          placeholder="Search users..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* User List */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        {loading ? (
          <div className="flex items-center justify-center h-48">
            <div className="spinner w-8 h-8"></div>
          </div>
        ) : filteredUsers.length === 0 ? (
          <div className="text-center py-12 text-gray-500">
            <p className="text-4xl mb-2">👥</p>
            <p>No users found</p>
          </div>
        ) : (
          <div className="divide-y">
            {filteredUsers.map(user => (
              <Link
                key={user.id}
                to={`/admin/users/${user.id}`}
                className="block p-4 hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 bg-rdi-blue rounded-full flex items-center justify-center text-white font-semibold">
                      {user.fullName?.charAt(0) || user.userName?.charAt(0) || '?'}
                    </div>
                    <div>
                      <p className="font-medium text-gray-800">{user.fullName || user.userName}</p>
                      <p className="text-sm text-gray-500">{user.userName}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    {user.isSysAdmin && (
                      <span className="status-badge bg-red-100 text-red-800">Sys Admin</span>
                    )}
                    {user.isAdmin && !user.isSysAdmin && (
                      <span className="status-badge bg-blue-100 text-blue-800">Admin</span>
                    )}
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
